// Components
import Icon from 'components/lib/Icon';

// antd draws its own icons (anticon-down, -close-circle, …) next to the Lucide ones the app uses.
// These are the ConfigProvider slots that replace them app-wide, so no call site passes an icon.
// Sort arrows and pagination arrows have no such slot: see components/Table/tableIcons.tsx.
const CHEVRON_SIZE = 16;
const CLEAR_SIZE = 14;
const REMOVE_SIZE = 12;

export const ANTD_ICON_CONFIG = {
  select: {
    suffixIcon: <Icon name="chevron-down" size={CHEVRON_SIZE} tone="textMuted" />,
    clearIcon: <Icon name="circle-x" size={CLEAR_SIZE} />,
    removeIcon: <Icon name="x" size={REMOVE_SIZE} />,
    menuItemSelectedIcon: <Icon name="check" size={CHEVRON_SIZE} />,
  },
  datePicker: { clearIcon: <Icon name="circle-x" size={CLEAR_SIZE} /> },
  timePicker: { clearIcon: <Icon name="circle-x" size={CLEAR_SIZE} /> },
  modal: { closeIcon: <Icon name="x" size={CHEVRON_SIZE} /> },
  drawer: { closeIcon: <Icon name="x" size={CHEVRON_SIZE} /> },
  tag: { closeIcon: <Icon name="x" size={REMOVE_SIZE} /> },
  notification: { closeIcon: <Icon name="x" size={CHEVRON_SIZE} /> },
};
